import { useDispatch, useSelector } from "react-redux";
import HeaderBar from "../../common/HeaderBar";
import SideBar from "../../common/SideBar";
import ProfileBody from "./ProfileBody";
import { profileCompletionPercentage } from "../../../Redux/profile/profile.action";
import { useEffect, useState } from "react";

const ProfilePage = () => {
  const dispatch = useDispatch();
  const [showSidebar, setShowSidebar] = useState(false);
  const profileCompletion = useSelector(
    (state) => state?.ProfileManager?.completion?.profile_completion
  );
  useEffect(() => {
    dispatch(profileCompletionPercentage());
  }, [dispatch]);

  useEffect(() => {
    if (profileCompletion > 80) {
      setShowSidebar(true);
    } else {
      setShowSidebar(false);
    }
  }, [profileCompletion]);

  const handleProfileSuccess = () => {
    setShowSidebar(true);
  };

  return (
    <main className="ff2 main-page">
      <HeaderBar />
      <div className="overflow-hidden inner-page-content ">
        {showSidebar && <SideBar />}
        <ProfileBody onProfileUpdateSuccess={handleProfileSuccess} />
      </div>
    </main>
  );
};

export default ProfilePage;
